module.exports = __webpack_public_path__ + "media/images/flags/4x3/lao-25a36cc11e1bbad8f508f76b43f3e141.svg";